<template>
  <v-card flat class="sstruct-list pa-2 mr-6 mt-6 ml-8">
    <s-struct
      v-for="(SStruct, index) in SStructArray"
      :s-struct="SStruct"
      :key="'sstruct-index-' + index"
      @delete="deleteSStruct(index)"
    >
    </s-struct>
    <v-card-actions>
      <template v-if="$store.getters.loadedSBlockTypes">
        <v-btn color="#1f51a4" class="ma-4" @click="openSStructTypeSelection = true">
          <span class="white--text">
            + Добавить
          </span>
        </v-btn>
        <v-dialog v-model="openSStructTypeSelection" max-width="40%">
          <s-struct-type-selection :s-block-type-id="SBlockTypeId" @selected="addSStruct">
          </s-struct-type-selection>
        </v-dialog>
      </template>
      <template v-else>
        <v-progress-circular
          indeterminate
          color="#1f51a4"
        ></v-progress-circular>
      </template>
    </v-card-actions>
  </v-card>
</template>

<script>
import SStruct from './SStruct'
import SStructTypeSelection from './SStructTypeSelection'
export default {
  name: 'SStructsList',
  components: { SStructTypeSelection, SStruct },
  props: {
    SStructArray: {
      type: Array,
      required: true
    },
    SBlockTypeId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      openSStructTypeSelection: false
    }
  },
  methods: {
    addSStruct (SStructType) {
      const newSStructType = {
        name: SStructType.name,
        description: SStructType.description
      }
      const newSStruct = {
        type: newSStructType,
        text: '',
        timing: ''
      }
      this.SStructArray.push(newSStruct)
      this.openSStructTypeSelection = false
    },
    deleteSStruct (SStructIndex) {
      this.SStructArray.splice(SStructIndex, 1)
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/colors';
  .sstruct-list {
    background-color: white;
  }
</style>
